"use client"
import { useNavigate } from "react-router-dom"

const SuccessModal = ({ success }) => {
  const navigate = useNavigate()

  if (!success) return null

  return (
    <div className="product-modal-overlay">
      <div className="product-success-modal">
        <div className="success-icon">✓</div>
        <h3>Order Submitted Successfully!
          <p style={{fontSize:'1.2rem',color:'red'}}>Payment is under verification by the depot.You will be notified once confirmed.</p>
        </h3>
      
        <button className="close-btn" onClick={() => navigate("/dashboard")}>
          Close
        </button>
      </div>
    </div>
  )
}

export default SuccessModal
